import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=b0ae0e7c&"
import script from "./attachment.component.ts?vue&type=script&lang=ts&"
export * from "./attachment.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ae0e7c')) {
      api.createRecord('b0ae0e7c', component.options)
    } else {
      api.reload('b0ae0e7c', component.options)
    }
    module.hot.accept("./attachment.vue?vue&type=template&id=b0ae0e7c&", function () {
      api.rerender('b0ae0e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/ChatRoom/components/attachment.vue"
export default component.exports